import { useEffect, useState } from 'react'

import { ID, WordList } from '../shared/types/api'
import * as API_STATISTIC from '../shared/http/statistic'
import WordListUtils from '../components/utils/WordListUtils'


export function useDebounce<T>(value: T, delay: number) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(handler);
    }, [value, delay]);

    return debounced;
}